import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  method: {},
  isInChallenge: false,
  attemptsCount: 0,
  paymentStatus: null,
};

const slice = createSlice({
  name: 'payment',
  initialState: reHydrateStore('payment') || initialState,
  reducers: {
    setPayment: (state, { payload }) => payload,
    setPaymentMethod: (state, { payload }) => ({
      ...state,
      method: payload,
    }),
    setIsInChallenge: (state, { payload }) => ({
      ...state,
      isInChallenge: payload,
    }),
    setAttemptsCount: (state, { payload }) => ({
      ...state,
      attemptsCount: payload,
    }),
    setPaymentStatus: (state, { payload }) => ({
      ...state,
      paymentStatus: payload
    }),
    restore: () => initialState,
  },
});

export const {
  setPayment,
  setPaymentMethod,
  setIsInChallenge,
  setAttemptsCount,
  attemptsCount,
  setPaymentStatus,
  restore,
} = slice.actions;

export default slice.reducer;
